var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarPostSizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 15.8334H16.5C14.659 15.8334 13.1667 17.3258 13.1667 19.1667V31.1667C13.1667 33.0077 14.659 34.5 16.5 34.5H32.5C34.3409 34.5 35.8333 33.0077 35.8333 31.1667V19.1667C35.8333 17.3258 34.3409 15.8334 32.5 15.8334ZM16.5 13.8334C13.5545 13.8334 11.1667 16.2212 11.1667 19.1667V31.1667C11.1667 34.1122 13.5545 36.5 16.5 36.5H32.5C35.4455 36.5 37.8333 34.1122 37.8333 31.1667V19.1667C37.8333 16.2212 35.4455 13.8334 32.5 13.8334H16.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 11.5C19.7189 11.5 20.1667 11.9477 20.1667 12.5V13.8333C20.1667 14.3856 19.7189 14.8333 19.1667 14.8333C18.6144 14.8333 18.1667 14.3856 18.1667 13.8333V12.5C18.1667 11.9477 18.6144 11.5 19.1667 11.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8333 11.5C30.3856 11.5 30.8333 11.9477 30.8333 12.5V13.8333C30.8333 14.3856 30.3856 14.8333 29.8333 14.8333C29.2811 14.8333 28.8333 14.3856 28.8333 13.8333V12.5C28.8333 11.9477 29.2811 11.5 29.8333 11.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.114 19.1666H18.886C18.3105 19.1666 17.8333 19.62 17.8333 20.1666C17.8333 20.7133 18.3105 21.1666 18.886 21.1666H30.114C30.6895 21.1666 31.1667 20.7133 31.1667 20.1666C31.1667 19.62 30.6895 19.1666 30.114 19.1666Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPostSizer);
export default __webpack_public_path__ + "static/media/calendarPostSizer.cf87095e.svg";
export { ForwardRef as ReactComponent };